var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13C9.6134 13.3866 8.9866 13.3866 8.6 13C8.2134 12.6134 8.2134 11.9866 8.6 11.6L12.2 8.00005H0.999999C0.447714 8.00005 0 7.55233 0 7.00005C0 6.44776 0.447716 6.00005 1 6.00005H12.2L8.6 2.40005C8.2134 2.01345 8.2134 1.38665 8.6 1.00005C8.9866 0.613449 9.6134 0.61345 10 1.00005L15.2929 6.29294C15.6834 6.68347 15.6834 7.31663 15.2929 7.70716L10 13Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.1d3a36d1c377ec4a8cdf35b464a1203f.svg";
export { ForwardRef as ReactComponent };